(function () {
  'use strict';

  var ROUTES = {
    '/pages/custom-gym-wear-manufacturer': {
      label: 'Gym Wear & Activewear',
      autoSelect: true,
      products: [
        ['oversized_gym_tees', 'Oversized Gym Tees', '👕'],
        ['pump_covers', 'Pump Covers', '👕'],
        ['stringers_tanks', 'Stringers & Tanks', '🏋️'],
        ['compression_wear', 'Compression Wear', '🏃'],
        ['gym_shorts', 'Gym Shorts', '🩳'],
        ['sports_bras', 'Sports Bras', '🏃'],
        ['leggings', 'Leggings', '🏃'],
        ['activewear_sets', 'Activewear Sets', '📦']
      ]
    },
    '/pages/custom-tracksuit-manufacturer': {
      label: 'Tracksuits, Joggers & Sweatpants',
      autoSelect: true,
      products: [
        ['fleece_tracksuits', 'Fleece Tracksuits', '👟'],
        ['zip_up_tracksuits', 'Zip-Up Tracksuits', '👟'],
        ['training_tracksuits', 'Training Tracksuits', '🏃'],
        ['streetwear_tracksuits', 'Streetwear Tracksuits', '🧥'],
        ['jogger_sets', 'Jogger Sets', '👖'],
        ['sweatpants', 'Sweatpants', '👖'],
        ['track_pants', 'Track Pants', '🏃'],
        ['team_tracksuits', 'Team Tracksuits', '🏅']
      ]
    },
    '/pages/custom-leather-jacket-manufacturer': {
      label: 'Leather Jackets',
      autoSelect: true,
      products: [
        ['biker_leather_jackets', 'Biker Leather Jackets', '🧥'],
        ['bomber_leather_jackets', 'Bomber Leather Jackets', '🧥'],
        ['aviator_leather_jackets', 'Aviator Leather Jackets', '🧥'],
        ['cafe_racer_jackets', 'Café Racer Jackets', '🏍️'],
        ['varsity_leather_jackets', 'Varsity Leather Jackets', '🧥'],
        ['suede_jackets', 'Suede Jackets', '🧥'],
        ['cropped_leather_jackets', 'Cropped Leather Jackets', '🧥'],
        ['leather_vests', 'Leather Vests', '🦺']
      ]
    },
    '/pages/custom-varsity-jacket-manufacturer': {
      label: 'Varsity Jackets',
      autoSelect: true,
      products: [
        ['wool_varsity_jackets', 'Wool Varsity Jackets', '🧥'],
        ['leather_sleeve_varsity', 'Leather-Sleeve Varsity Jackets', '🧥'],
        ['satin_varsity_jackets', 'Satin Varsity Jackets', '🧥'],
        ['chenille_varsity_jackets', 'Chenille Patch Varsity Jackets', '🔤'],
        ['embroidered_varsity_jackets', 'Embroidered Varsity Jackets', '🪡'],
        ['streetwear_varsity_jackets', 'Streetwear Varsity Jackets', '🧥'],
        ['school_varsity_jackets', 'School Varsity Jackets', '🎓'],
        ['team_varsity_jackets', 'Team Varsity Jackets', '🏅']
      ]
    },
    '/pages/custom-uniform-manufacturer': {
      label: 'Uniforms & Workwear',
      autoSelect: true,
      products: [
        ['corporate_uniforms', 'Corporate Uniforms', '👔'],
        ['school_uniforms', 'School Uniforms', '🎓'],
        ['hospitality_uniforms', 'Hospitality Uniforms', '🧑‍🍳'],
        ['workwear', 'Workwear', '🦺'],
        ['medical_scrubs', 'Medical Scrubs', '🩺'],
        ['staff_tshirts', 'Staff T-Shirts', '👕'],
        ['branded_polos', 'Branded Polo Shirts', '👕'],
        ['security_uniforms', 'Security Uniforms', '🛡️']
      ]
    },
    '/pages/custom-denim-manufacturer': {
      label: 'Custom Denim',
      autoSelect: true,
      products: [
        ['custom_jeans', 'Custom Jeans', '👖'],
        ['denim_jackets', 'Denim Jackets', '🧥'],
        ['denim_shirts', 'Denim Shirts', '👕'],
        ['cargo_denim', 'Cargo Denim', '👖'],
        ['denim_shorts', 'Denim Shorts', '🩳'],
        ['denim_skirts', 'Denim Skirts', '👗'],
        ['oversized_denim', 'Oversized Denim', '🧥'],
        ['other_denim', 'Other Denim Garments', '📦']
      ]
    },
    '/pages/custom-accessories-manufacturer': {
      label: 'Caps, Bags & Accessories',
      autoSelect: true,
      products: [
        ['custom_caps', 'Custom Caps', '🧢'],
        ['beanies', 'Beanies', '🧶'],
        ['bucket_hats', 'Bucket Hats', '👒'],
        ['tote_bags', 'Tote Bags', '👜'],
        ['backpacks', 'Backpacks', '🎒'],
        ['custom_patches', 'Custom Patches', '🪡'],
        ['labels_hang_tags', 'Labels & Hang Tags', '🏷️'],
        ['custom_packaging', 'Custom Packaging', '📦']
      ]
    },
    '/pages/private-label-clothing-manufacturer': {
      label: 'Private Label Clothing',
      autoSelect: false,
      products: [
        ['private_label_tshirts', 'T-Shirts', '👕'],
        ['private_label_hoodies', 'Hoodies & Sweatshirts', '👕'],
        ['private_label_tracksuits', 'Tracksuits & Joggers', '👟'],
        ['private_label_sportswear', 'Sportswear & Activewear', '🏃'],
        ['private_label_jackets', 'Jackets & Outerwear', '🧥'],
        ['private_label_uniforms', 'Uniforms & Workwear', '👔'],
        ['private_label_denim', 'Denim', '👖'],
        ['private_label_accessories', 'Caps, Bags & Accessories', '🧢']
      ]
    }
  };

  function normalisePath(path) {
    var normalised = (path || '/').replace(/\/$/, '') || '/';
    normalised = normalised.replace(/^\/(?:de|fr)(?=\/)/, '');
    return normalised || '/';
  }

  function currentConfig() {
    return ROUTES[normalisePath(window.location.pathname)] || null;
  }

  function deduplicateQuantityOptions(section) {
    var selects = section.querySelectorAll('select[id^="qf-quantity-"]');
    selects.forEach(function (select) {
      var seen = Object.create(null);
      Array.from(select.options).forEach(function (option) {
        if (!option.value) return;
        if (seen[option.value]) {
          option.remove();
        } else {
          seen[option.value] = true;
        }
      });
    });
  }

  function addSourceFields(form, categoryLabel) {
    if (!form || form.querySelector('input[name="contact[source_page]"]')) return;
    var canonicalEl = document.querySelector('link[rel="canonical"]');
    var canonical = canonicalEl ? canonicalEl.href : window.location.href.split('#')[0];
    var fields = {
      'contact[lead_category]': categoryLabel || document.title,
      'contact[source_page]': window.location.pathname,
      'contact[source_url]': canonical,
      'contact[referrer]': document.referrer || 'Direct / unavailable'
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
  }

  function applyCategoryProducts(section, config) {
    if (!config) return;
    var grid = section.querySelector('.cat-qf-product-grid');
    if (!grid) return;
    var buttons = Array.from(grid.querySelectorAll('.cat-qf-product-btn'));
    if (!buttons.length) return;

    buttons.forEach(function (button, index) {
      var product = config.products[index];
      if (!product) {
        button.hidden = true;
        button.style.display = 'none';
        return;
      }
      button.hidden = false;
      button.style.display = '';
      button.dataset.value = product[0];
      var icon = button.querySelector('.cat-qf-product-icon');
      var name = button.querySelector('.cat-qf-product-name');
      if (icon) icon.textContent = product[2];
      if (name) name.textContent = product[1];
      button.classList.remove('active');
      button.setAttribute('aria-pressed', 'false');
    });

    var form = section.querySelector('form');
    if (form) form.dataset.leadCategory = config.label;

    if (config.autoSelect && buttons[0] && !buttons[0].hidden) {
      buttons[0].click();
    } else {
      var hidden = section.querySelector('input[id^="qf-product-type-"]');
      if (hidden) hidden.value = '';
    }
  }

  function initialiseForms() {
    var config = currentConfig();
    document.querySelectorAll('.cat-quote').forEach(function (section) {
      applyCategoryProducts(section, config);
      deduplicateQuantityOptions(section);
      addSourceFields(section.querySelector('form'), config ? config.label : document.title);
    });
  }

  function trackingDetails() {
    var config = currentConfig();
    var canonicalEl = document.querySelector('link[rel="canonical"]');
    var params = new URLSearchParams(window.location.search);
    var campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
    var campaigns = [];
    campaignKeys.forEach(function (key) {
      if (params.get(key)) campaigns.push(key + ': ' + params.get(key));
    });
    return {
      category: config ? config.label : (document.querySelector('.cat-quote__title') || {}).textContent || document.title,
      title: document.title,
      path: window.location.pathname,
      url: canonicalEl ? canonicalEl.href : window.location.href.split('#')[0],
      referrer: document.referrer || 'Direct / unavailable',
      campaign: campaigns.length ? campaigns.join(' | ') : 'None recorded'
    };
  }

  if (!window.__florixQuoteFetchPatched && typeof window.fetch === 'function') {
    window.__florixQuoteFetchPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      if (requestUrl.indexOf('api.web3forms.com/submit') !== -1 && init && typeof init.body === 'string') {
        try {
          var payload = JSON.parse(init.body);
          var source = trackingDetails();
          var sourceBlock = [
            '',
            '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
            '  LEAD SOURCE & PAGE ATTRIBUTION',
            '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
            '  Lead Category : ' + source.category,
            '  Page Title    : ' + source.title,
            '  Source Path   : ' + source.path,
            '  Canonical URL : ' + source.url,
            '  Referrer      : ' + source.referrer,
            '  Campaign Data : ' + source.campaign
          ].join('\n');
          payload.message = (payload.message || '') + sourceBlock;
          payload.subject = (payload.subject || 'New Quote Request') + ' — ' + source.category;
          init = Object.assign({}, init, { body: JSON.stringify(payload) });
        } catch (error) {
          console.warn('Florix quote attribution could not be appended.', error);
        }
      }
      return nativeFetch.call(this, input, init);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseForms);
  } else {
    initialiseForms();
  }
})();
